module.exports = __webpack_public_path__ + "static/img/bg-tr.4c9b4917.png";